import LitView from './lib/lit-view';
export default LitView;
